
import { db, doc, onSnapshot, addDoc, getDoc, setDoc, writeBatch, collection, serverTimestamp } from './firebaseConfig.js';
import { fp } from "./stores/fingerprint.js";
import { messages } from "./stores/messages.js";
import { get } from 'svelte/store';
import { station } from './stores/station.js';
import { push, pop, replace } from 'svelte-spa-router'
import { updateDoc } from 'firebase/firestore';
import { setAddSongCooldown, setSaySomethingCooldown } from './stores/cooldownTimer.js';

export const settings = {
    // WAIT: 5000
    WAIT: 3 * 60 * 1000 //wait time before adding song (3 minutes)
    // WAIT: 60 * 1000 //wait time before adding song (60 seconds)
}

export let currentStation;

function generateId() {
    var r = Math.round(Math.random() * 1632960 + 46655);
    r = r.toString(36).toUpperCase();
    return r
}

async function getStationId() {
    let id;
    let taken = true;
    while (taken) {
        id = generateId();
        const docRef = doc(db, "stations", id);
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists())
            taken = false;
    }
    return id;
}

export async function newStation() {
    const userFp = get(fp)
    const newStationId = await getStationId();

    var station = {
        id: newStationId,
        settings,
        state: "paused",
        nowPlaying: null,
        creatorsFingerprint: userFp,
        admin: userFp,
        title: 'cool station sis',
        users: {
            [userFp]: {
                addedSongAt: 0
            }
        },
        playlistUid: 0,
        playlist: []
    };

    try {

        const docRef = doc(db, "stations", newStationId);

        await setDoc(docRef, station);

        return newStationId;

    } catch (e) {
        console.error(e);
    }
}

let us_station = null;
let us_messages = null;

export async function joinStation(stationId) {

    const stationDocRef = doc(db, "stations", stationId);
    const stationSnap = await getDoc(stationDocRef);

    if (!stationSnap.exists()) {
        console.log("can't find station");
        station.set(false);
        return;
    }

    const currentStation = stationSnap.data();
    const userFp = get(fp);

    if (!currentStation.users[userFp]) {
        currentStation.users[userFp] = {
            addedSongAt: 0
        }
    }

    try {

        await updateDoc(stationDocRef, currentStation);

        us_station = onSnapshot(stationDocRef, (docSnap) => {
            if (docSnap.exists) {
                let stationData = docSnap.data();
                station.set(stationData);

                let addedSongAt = stationData.users[userFp].addedSongAt || 0;
                let AddSongCooldownTimeLeft = currentStation.settings.WAIT - (Date.now() - addedSongAt);
                if (AddSongCooldownTimeLeft > 0) {
                    console.log("cooldown left: " + AddSongCooldownTimeLeft)
                    setAddSongCooldown(AddSongCooldownTimeLeft);
                }

                let saidSomethingAt = stationData.users[userFp].saidSomethingAt || 0;
                let saySomethingCooldownTimeLeft = currentStation.settings.WAIT - (Date.now() - saidSomethingAt);
                if (saySomethingCooldownTimeLeft > 0) {
                    console.log("cooldown left: " + saySomethingCooldownTimeLeft)
                    setSaySomethingCooldown(saySomethingCooldownTimeLeft);
                }
            }
        });

        const messagesRef = collection(db, "stations", currentStation.id, "messages");

        us_messages = onSnapshot(messagesRef, (snapshot) => {
            const msgs = [];

            // Iterate through each document in the snapshot
            snapshot.forEach(doc => {
                msgs.push(doc.data());
            });
            messages.set(msgs);
        });

    } catch (err) {
        console.error(err);
    }
}

export function leaveStation() {
    if (us_station) us_station();
    if(us_messages) us_messages();
    us_station = null;
    station.set(null);
}

export async function addVideo(video) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: cannot add video");
        return false;
    }

    var user = currentStation.users[userFp];
    var now = Date.now();
    if (now - user.addedSongAt > currentStation.settings.WAIT) {
        user.addedSongAt = now;
        video.likes = { [userFp]: true }
        video.dislikes = {};
        video.uid = currentStation.playlistUid++;
        currentStation.playlist.push(video);
        sortPlaylist(currentStation);

        const docRef = doc(db, "stations", currentStation.id);
        await updateDoc(docRef, currentStation);

        setAddSongCooldown(currentStation.settings.WAIT);

    } else {
        console.log('you need to wait ' + ((currentStation.settings.WAIT - (now - user.addedSongAt)) / 1000).toString() + ' seconds');
        return false;
    }
}

function sort(playlist) {
    let sorted = playlist.sort((va, vb) => {
        let aSum = Object.keys(va.likes).length - Object.keys(va.dislikes).length
        let bSum = Object.keys(vb.likes).length - Object.keys(vb.dislikes).length
        return bSum - aSum;
    });
    return sorted;
}

function sortPlaylist(stationObj) {
    //if a song is playing then we only reorder the songs beneth the one currently playing
    if (stationObj.nowPlaying) {
        let nowPlayingIdx = stationObj.playlist.findIndex(v => v.videoId == stationObj.nowPlaying.videoId);
        let beforeNowPlaying = stationObj.playlist.slice(0, nowPlayingIdx + 1);
        let afterNowPlaying = stationObj.playlist.slice(nowPlayingIdx + 1, stationObj.playlist.length);
        let sorted = sort(afterNowPlaying);
        stationObj.playlist = beforeNowPlaying.concat(sorted);
    } else {
        stationObj.playlist = sort(stationObj.playlist);
    }
}

export async function setPlayerState(data, video) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    if (userFp != currentStation.admin) {
        console.error("Error: only admins can change state");
        return false;
    }

    if (data != 10) {
        if (!video) {
            if (data === 10) {
                currentStation.nowPlaying = { title: "Party's over" };
            } else {
                currentStation.nowPlaying = { title: "Free Stylin" };
            }
        } else {
            let currentVideo = currentStation.playlist.find(v => v.uid === video.uid);
            if (!currentVideo) {
                currentStation.nowPlaying = { title: "Free Stylin" };
            } else {
                currentStation.nowPlaying = currentVideo;
            }
        }
    }

    // if (data == 1) {
    //     console.log(data);
    // }

    switch (data) {
        case -1:
        case 0:
        case 2:
            currentStation.state = "paused";
            break;
        case 1:
            currentStation.state = "playing";
            break;
        case 3:
            currentStation.state = "buffering";
            break;
        case 10:
            currentStation.state = "Host has left! 😵";
            break;
        default:
            currentStation.state = null
    }

    const docRef = doc(db, "stations", currentStation.id);
    await updateDoc(docRef, currentStation);
}

export async function likeVideo(videoId) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    let vid = currentStation.playlist.find(v => v.uid === videoId);
    if (!vid) {
        console.error("Error: likeVideo() video is not in the list");
        return;
    }

    vid.likes[userFp] = true;
    if (vid.dislikes[userFp])
        delete vid.dislikes[userFp];

    sortPlaylist(currentStation);

    const docRef = doc(db, "stations", currentStation.id);
    await updateDoc(docRef, currentStation);
}

export async function dislikeVideo(videoId) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    let vid = currentStation.playlist.find(v => v.uid === videoId);
    if (!vid) {
        console.error("Error: likeVideo() video is not in the list");
        return;
    }

    vid.dislikes[userFp] = true;
    if (vid.likes[userFp])
        delete vid.likes[userFp];

    sortPlaylist(currentStation);

    const docRef = doc(db, "stations", currentStation.id);
    await updateDoc(docRef, currentStation);
}

export async function clearLike(videoId) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    let vid = currentStation.playlist.find(v => v.uid === videoId);
    if (!vid) {
        console.error("Error: likeVideo() video is not in the list");
        return;
    }

    if (vid.likes[userFp])
        delete vid.likes[userFp];

    sortPlaylist(currentStation);

    const docRef = doc(db, "stations", currentStation.id);
    await updateDoc(docRef, currentStation);
}

export async function clearDislike(videoId) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    let vid = currentStation.playlist.find(v => v.uid === videoId);
    if (!vid) {
        console.error("Error: likeVideo() video is not in the list");
        return;
    }

    if (vid.dislikes[userFp])
        delete vid.dislikes[userFp];

    sortPlaylist(currentStation);

    const docRef = doc(db, "stations", currentStation.id);
    await updateDoc(docRef, currentStation);
}

export async function saySomething(msg) {
    const currentStation = get(station);
    const userFp = get(fp);

    if (!currentStation || !userFp) {
        console.error("Error: setPlayerState");
        return false;
    }

    var user = currentStation.users[userFp];
    var now = Date.now();

    if (!user.saidSomethingAt || now - user.saidSomethingAt > currentStation.settings.WAIT) {

        // const batch = writeBatch(db);

        user.saidSomethingAt = now;

        const docRef = doc(db, "stations", currentStation.id);

        await updateDoc(docRef, currentStation);

        // const docRef = doc(db, "stations", currentStation.id).collection("messages").doc();
        const messagesRef = doc(db, "stations", currentStation.id, "messages", userFp);
        await setDoc(messagesRef, {
            msg,
            userFp,
            timestamp: serverTimestamp(),
        });

        setSaySomethingCooldown(currentStation.settings.WAIT);

        // await batch.commit();

    } else {
        console.log('you need to wait ' + ((currentStation.settings.WAIT - (now - user.saidSomethingAt)) / 1000).toString() + ' seconds');
        return false;
    }
}
